import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './store/root-reducer';
import { PreloadedState } from '@reduxjs/toolkit';

const controller = process.env.REACT_APP_SPA_ROOT || '';
const pathName = window.location.pathname.toLocaleLowerCase();
const spaPath = pathName.substring(
    0,
    pathName.indexOf(controller) + controller.length
);

export const setupStore = (preloadedState?: PreloadedState<RootState>) => {
    return configureStore({
        reducer: rootReducer,
        preloadedState: { spaPath, ...preloadedState },
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: false,
                immutableCheck: false, // todo: I had to turn these checks off in order to upgrade npm packages without it erroring. We should get rid of it, but this is a bandaid till we have a work item for it
            }),
    });
};
export const store = setupStore();

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export type AppStore = ReturnType<typeof setupStore>;
